// Display-only scoping of the shared `assets` collection into two sidebar views.
// No data model change — assets are filtered by their existing `sale_type_id` (matched
// against these Sale Type labels). Assets whose Sale Type is blank or not in either set
// appear in neither view but remain reachable via direct link / Reports.
export const ASSET_SCOPES = {
  auction: {
    key: "auction",
    navLabel: "Auction Assets",
    title: "Auction Assets",
    eyebrow: "Inventory · Auction",
    statusMode: "active",
    saleTypeLabels: [
      "E-Auction (SARFAESI)",
      "E-Auction (NCLT Liquidation)",
      "Swiss Challenge",
      "Tender/EOI-based",
    ],
    defaultSaleTypeLabel: "E-Auction (SARFAESI)",
    path: "/assets/auction",
  },
  land: {
    key: "land",
    navLabel: "Land & Other Assets",
    title: "Land & Other Assets",
    eyebrow: "Inventory · Land & Other",
    statusMode: "active",
    saleTypeLabels: [
      "Private Treaty / OTS",
      "Negotiated Sale",
      "Slump Sale",
      "Item-wise Sale",
    ],
    defaultSaleTypeLabel: "Private Treaty / OTS",
    path: "/assets/land",
  },
  archived: {
    key: "archived",
    navLabel: "Archived Assets",
    title: "Archived Assets",
    eyebrow: "Inventory · Archived",
    statusMode: "archived",
    saleTypeLabels: [],
    noAdd: true,
    path: "/assets/archived",
  },
};

// Terminal / non-active statuses shown in Archived Assets.
export const ARCHIVED_STATUSES = ["Won", "Lost", "Closed", "Expired", "On Hold due to Litigation", "Inactive"];

// Land & Other sale types show a simplified form/detail (Offer Price + Possession Type only).
// A blank/unknown sale type is treated as NOT land (full auction form shown).
export function isLandSaleType(label) {
  return ASSET_SCOPES.land.saleTypeLabels.includes(label);
}

// Section of a Sale Type taxonomy option. Prefers the dynamic `asset_section` field
// (set in Master Data); falls back to the legacy label heuristic for any value that
// hasn't been tagged yet. Returns "auction" | "resale" | null.
export function saleTypeSection(option) {
  if (!option) return null;
  if (option.asset_section === "auction" || option.asset_section === "resale") {
    return option.asset_section;
  }
  if (!option.label) return null;
  return isLandSaleType(option.label) ? "resale" : "auction";
}

